import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import config from "../../config";

const extractFilename = (disposition, fallback) => {
  if (!disposition) return fallback;

  const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1].trim().replace(/^["']|["']$/g, ""));
    } catch {
      return utf8Match[1].trim().replace(/^["']|["']$/g, "");
    }
  }

  const plainMatch = disposition.match(/filename=["']?([^"';\n]+)/i);
  if (plainMatch?.[1]) {
    return plainMatch[1].trim();
  }

  return fallback;
};

const ExportExcelButton = ({
  endpoint,
  filter = "",
  orderBy = "",
  fileName = "export.xlsx",
  className = "",
}) => {
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (filter) params.set("filter", filter);
      if (orderBy) params.set("orderBy", orderBy);

      const query = params.toString();
      const url = query ? `${endpoint}?${query}` : endpoint;

      const response = await axios.get(url, {
        responseType: "blob",
        headers: {
          HeaderKey: config.HeaderKey,
        },
        withCredentials: true,
      });

      const contentType = response.headers["content-type"] || "";
      if (contentType.includes("application/json")) {
        const text = await response.data.text();
        let message = "خروجی اکسل با خطا مواجه شد";
        try {
          const parsed = JSON.parse(text);
          message = parsed?.message || parsed?.title || message;
        } catch {
          /* keep default */
        }
        toast.error(
          <p dir="rtl" className="font-custom">
            {message}
          </p>
        );
        return;
      }

      const disposition = response.headers["content-disposition"];
      const downloadName = extractFilename(disposition, fileName);
      const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", downloadName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);

      toast.success(
        <p dir="rtl" className="font-custom">
          فایل اکسل با موفقیت دانلود شد
        </p>
      );
    } catch (err) {
      if (err.response?.status === 400) {
        let message = "فیلتر نامعتبر است";
        const data = err.response.data;
        if (data instanceof Blob) {
          try {
            const text = await data.text();
            const parsed = JSON.parse(text);
            message = parsed?.message || parsed?.title || message;
          } catch {
            /* keep default */
          }
        } else if (typeof data === "object" && data?.message) {
          message = data.message;
        }
        toast.error(
          <p dir="rtl" className="font-custom">
            {message}
          </p>
        );
      } else if (err.response?.status === 401) {
        toast.error(
          <p dir="rtl" className="font-custom">
            نشست شما منقضی شده است
          </p>
        );
      } else {
        toast.error(
          <p dir="rtl" className="font-custom">
            خروجی اکسل با خطا مواجه شد
          </p>
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      disabled={loading}
      onClick={handleExport}
      className={
        className ||
        "bg-emerald-700 hover:bg-emerald-600 disabled:opacity-60 disabled:cursor-not-allowed text-white font-semibold py-2 px-4 rounded-full shadow-md transition duration-300 mb-5"
      }
    >
      {loading ? "در حال آماده‌سازی..." : "خروجی اکسل"}
    </button>
  );
};

export default ExportExcelButton;
